import mlApi from '@/api/ml';

const KINDS = ['classification', 'multiclass', 'regression', 'clustering', 'anomaly'];

const state = () => {
  const lists = {};
  const loadings = {};
  KINDS.forEach(k => {
    lists[k] = [];
    loadings[`${k}Loading`] = false;
  });
  return { lists, loadings };
};

const mutations = {
  SET_MODELS(state, { kind, models }) {
    state.lists[kind] = models;
  },
  SET_LOADING(state, { kind, val }) {
    state.loadings[`${kind}Loading`] = val;
  },
  REMOVE_MODEL(state, { kind, id }) {
    state.lists[kind] = state.lists[kind].filter(m => m.id !== id);
  },
};

const apiMap = {
  classification: { list: 'listClassificationModels', del: 'deleteClassificationModel' },
  multiclass:     { list: 'listMulticlassModels',     del: 'deleteMulticlassModel' },
  regression:     { list: 'listRegressionModels',     del: 'deleteRegressionModel' },
  clustering:     { list: 'listClusteringModels',     del: 'deleteClusteringModel' },
  anomaly:        { list: 'listAnomalyModels',        del: 'deleteAnomalyModel' },
};

const actions = {
  loadModels({ commit }, kind) {
    commit('SET_LOADING', { kind, val: true });
    mlApi[apiMap[kind].list]()
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200 && resp.data.result) {
          commit('SET_MODELS', { kind, models: resp.data.result });
        }
      })
      .finally(() => {
        commit('SET_LOADING', { kind, val: false });
      });
  },

  deleteModel({ commit, dispatch }, { kind, id }) {
    mlApi[apiMap[kind].del](id)
      .then(resp => {
        if (resp.data && resp.data.statusCode === 200) {
          commit('REMOVE_MODEL', { kind, id });
          dispatch('loadModels', kind);
        }
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
